import React from "react";
import { Box, Grow } from "@mui/material";
// @ts-ignore
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";

// Helper function to extract video ID from YouTube URL
const extractVideoId = (url: string) => {
  const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|watch)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

function VideoModal({ isOpen, close, videoUrl }: { isOpen: boolean; close: () => void; videoUrl: string }) {
  const videoId = extractVideoId(videoUrl);

  return (
    <div>
      <Grow in={isOpen} mountOnEnter unmountOnExit>
        <Box>
          <ModalVideo
            channel="youtube"
            autoplay
            loop
            isOpen={isOpen} 
            videoId={videoId}
            onClose={close}
          />
        </Box>
      </Grow>
    </div>
  );
}

export default VideoModal;
